import { updateObject } from 'utils/helpers/updateObject';
import { actionTypes, LoginActions, LoginFailAction, LoginRequestAction, LoginSuccessAction, ResetAuthAction, stateStatusType } from './actionType';
import { initialState, LoginStateProps } from './state';

const loginRequest = (state: LoginStateProps, action: LoginRequestAction) => {
    return updateObject(state, {
        authState: {
            ...state.authState,
            status: null,
            isLoading: true
        }
    });
};
const loginSuccess = (state: LoginStateProps, action: LoginSuccessAction) => {
    return updateObject(state, {
        authState: {
            ...state.authState,
            authUser: {
                ...action.payload
            },
            error: null,
            status: stateStatusType.SUCCESS,
            isLoading: false
        }
    });
};

const loginFail = (state: LoginStateProps, action: LoginFailAction) => {
    return updateObject(state, {
        authState: {
            ...state.authState,
            isLoading: false,
            status: stateStatusType.FAILED,
            error: action.payload
        }
    });
};


const resetAuth = (state: LoginStateProps, action: ResetAuthAction) => {
    return updateObject(state, {
        authState: {
            ...state.authState,
            authUser: null,
            error: null,
            status: null,
            isLoading: false
        }
    });
};

const loginReducer = (state = initialState, action: LoginActions) => {
    switch (action.type) {
        case actionTypes.LOGIN_REQUEST:
            return loginRequest(state, action);
        case actionTypes.LOGIN_SUCCESS:
            return loginSuccess(state, action);
        case actionTypes.LOGIN_FAIL:
            return loginFail(state, action);
        case actionTypes.RESET_AUTH:
                    return resetAuth(state, action);
        default:
            return state;
    }
};

export default loginReducer;
